/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

import { useEffect, useState } from "react";
import { getUserData } from "services/user-services";
import { useParams } from "react-router-dom";
import CategoriesChart from "./CategoriesChart";
import SubCategoriesPerGradeChartChart from "./SubCategoriesPerGradeChart";
import QuizzesPerSubcategoryChart from "./QuizzesPerSubcategoryChart";

function UserDetails(): JSX.Element {
  const [userData, setUserData] = useState({
    user: {subscriptionId: ''},
    categories: [],
    subcategories: [],
    quizzes: [],
  })
  const [grades, setGrades] = useState([])
  const params = useParams()

  useEffect(() => {
    (async () => {
      const userData = await getUserData(params.id)
      setUserData(userData)
    })()
  }, [])

  useEffect(() => {
    const allGrades = userData.subcategories.map(subcategory => subcategory.grade)
    const allGradesSet = new Set(allGrades)
    const allGradesArray = Array.from(allGradesSet).sort((a, b) => a.localeCompare(b))
    const grades = allGradesArray.map(grade => ({ grade, count: userData.subcategories.filter(subcategory => grade === subcategory.grade).length }))
    setGrades(grades)
  }, [userData])
  
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDBox mt={6}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              <CategoriesChart userData={userData} />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <SubCategoriesPerGradeChartChart grades={grades} />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <QuizzesPerSubcategoryChart userData={userData} />
            </Grid>
          </Grid>
        </MDBox>
        <MDBox mt={5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="dark"
                  icon="quiz"
                  title="# Quizzes"
                  count={userData.quizzes.length}

                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  icon="list_dropdown"
                  title="# Categories"
                  count={userData.categories.length}

                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="success"
                  icon="filter_list"
                  title="# Subcategories"
                  count={userData.subcategories.length}

                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="primary"
                  icon="calendar_month"
                  title="Subscription Id"
                  count={userData.user.subscriptionId}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default UserDetails;
